import { MainRouter } from "./main-router";
import { routes } from "./routes";
import { RoutingService } from "./routing-service";


export
{
    MainRouter as Router,
    routes,
    RoutingService
};

